import React, { useEffect } from 'react'

import ApproveModal from '../../../components/approveModal/index'
import { editScheduleModalsActions } from '../actions'
import { useEditScheduleEditorOperations, useAlertClassIds } from '../hooks'
import { useActions, useAppSelector } from '../../../store/hooks'
import { editSchedulePageSelector } from '../../../store/slices/editSchedulePage'
import { scheduleSelector } from '../../../store/slices/schedule'

const EditScheduleModals = () => {
    const { alertClassIds } = useAlertClassIds()

    const showDeleteModal = useAppSelector(editSchedulePageSelector.showDeleteModal)
    const deleteClassId = useAppSelector(editSchedulePageSelector.deleteClassId)
    const showCloseEditorModal = useAppSelector(editSchedulePageSelector.showCloseEditorModal)
    const pendingAction = useAppSelector(editSchedulePageSelector.pendingAction)
    const scheduleFilters = useAppSelector(editSchedulePageSelector.filters)
    const deleteLoading = useAppSelector(scheduleSelector.deleteLoading)
    const isFormDirty = useAppSelector(editSchedulePageSelector.isFormDirty)

    const {
        setShowDeleteModal,
        setShowCloseEditorModal,
        deleteLesson,
    } = useActions(editScheduleModalsActions)

    const { confirmCloseEditor } = useEditScheduleEditorOperations()

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            if (!isFormDirty) return

            const message = 'Вы не сохранили изменения. Уверены, что хотите покинуть страницу?'
            event.preventDefault()
            event.returnValue = message
            return message
        }

        window.addEventListener('beforeunload', handleBeforeUnload)
        return () => window.removeEventListener('beforeunload', handleBeforeUnload)
    }, [isFormDirty])

    const cancelDelete = () => {
        setShowDeleteModal({ open: false })
    }

    const confirmDelete = () => {
        deleteLesson({
            lessonId: deleteClassId,
            reloadClassIds: alertClassIds || null,
            reloadFilters: alertClassIds ? null : scheduleFilters,
        })

        cancelDelete()
    }

    return (
        <>
            <ApproveModal
                title="Удалить занятие?"
                text="Вы уверены, что хотите удалить это занятие? Данное действие нельзя будет отменить."
                onClick={confirmDelete}
                onCancel={cancelDelete}
                visible={showDeleteModal}
                confirmLoading={deleteLoading}
            />

            <ApproveModal
                title="Закрыть редактор?"
                text={
                    pendingAction?.type === 'changeMode'
                        ? 'Вы не сохранили изменения. При переключении режима все несохранённые данные будут потеряны. Продолжить?'
                        : 'Вы не сохранили изменения. Уверены, что хотите закрыть редактор?'
                }
                onClick={confirmCloseEditor}
                onCancel={() => setShowCloseEditorModal({ open: false })}
                visible={showCloseEditorModal}
            />
        </>
    )
}

export default EditScheduleModals
